import {Component, OnInit} from '@angular/core';
import {BaseComponent} from '../shared/components/base.component';
import {SetPasswordService} from './set-password.service';
import {ActivatedRoute, Router} from '@angular/router';
import {UserPreferencesService} from '../shared/service/user-preferences.service';
import {ApplicationConfig} from '../../config/application.config';
import {LoggerService} from '../shared/service/logger.service';
import { UpdatePassword } from '../shared/model/update-password';

@Component({
  selector: 'app-set-password',
  templateUrl: './set-password.component.html',
  styleUrls: ['./set-password.component.scss'],
  providers: [SetPasswordService]
})
export class SetPasswordComponent extends BaseComponent implements OnInit {

  public password: string;
  public confirmPassword: string;
  public isProccessing: boolean;
  public isPasswordCreationDone: boolean;
  public isPasswordCreationError: boolean;
  public logoUrl: string;
  public passwordResetCode: string;

  constructor(private setPasswordService: SetPasswordService, private router: Router, private route: ActivatedRoute,
              private userPreferencesService: UserPreferencesService, public applicationConfig: ApplicationConfig,
              private loggerService: LoggerService) {
    super();
  }

  ngOnInit() {
    this.password = '';
    this.confirmPassword = '';
    this.isPasswordCreationDone = false;
    this.isPasswordCreationError = false;
    this.isProccessing = false;
    this.logoUrl = this.userPreferencesService.getCompanyLogoUrl();
    this.route.params.subscribe(params => {
      this.passwordResetCode = params['passwordResetCode'];
    });
  }

  public onInputFocus() {
    this.isPasswordCreationError = false;
  }

  public areBothPasswordEqual(): boolean {
    return this.password === this.confirmPassword;
  }

  public doesPasswordHaveTargetedLenght(): boolean {
    return this.password.length >= this.applicationConfig.MIN_PASSWORD_LENGTH;
  }

  public goToLoginPage() {
    this.router.navigate(['login'], {relativeTo: this.route.parent});
  }

  public onSubmit() {
    this.isPasswordCreationError = false;
    this.isProccessing = true;
    this.setPasswordService.savePassword(new UpdatePassword(this.passwordResetCode, this.password)).subscribe(
      () => this.isPasswordCreationDone = true,
      error => {
        this.isProccessing = false;
        this.isPasswordCreationError = true;
        this.loggerService.error(`Could not save new user password cause of ${error.message}`);
      },
      () => this.isProccessing = false
    );
  }
}
